import { createAction } from '@reduxjs/toolkit';

export const setVersion = createAction<string>('app/version/setVersion');
export const setVersionOutdated = createAction<boolean>(
  'app/version/setVersionOutdated'
);
